import { render, staticRenderFns } from "./DocumentCards.vue?vue&type=template&id=46698a35&scoped=true"
import script from "./DocumentCards.vue?vue&type=script&lang=js"
export * from "./DocumentCards.vue?vue&type=script&lang=js"
import style0 from "./DocumentCards.vue?vue&type=style&index=0&id=46698a35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46698a35",
  null
  
)

export default component.exports